var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6838 0.380221L5.35385 5.71022C5.22352 5.84055 5.01252 5.84055 4.88252 5.71022L2.20607 3.03378C2.07574 2.90344 1.86474 2.90344 1.73474 3.03378L0.320406 4.44811C0.190073 4.57844 0.190073 4.78944 0.320406 4.91944L4.88252 9.48155C5.01285 9.61189 5.22385 9.61189 5.35385 9.48155L12.5695 2.26589C12.6998 2.13555 12.6998 1.92455 12.5695 1.79455L11.1552 0.380221C11.0252 0.249887 10.8142 0.249887 10.6838 0.380221Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.09fd5f36a4ec6c67c81e0dbe4716a67f.svg";
export { ForwardRef as ReactComponent };